import classNames from 'classnames'
import { html, LitElement } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { isNil } from '../lib/functional/nil.no-deps'
import type { IconName } from './helpers/icons'
import style from './style/zaptic-lozenge-style'

// https://www.figma.com/file/BpMdzCsfZAXmpHQCowcsWD/Global-Design-Library-(Master-%40-7f17203)?node-id=2122%3A39016&t=eV8Y3vpKRGFAEagr-0

export const LOZENGE_COLORS = ['orange', 'red', 'teal', 'green', 'grey'] as const

@customElement('zaptic-lozenge')
export class Lozenge extends LitElement {
    static styles = style

    @property()
    color: (typeof LOZENGE_COLORS)[number]

    @property()
    label: string

    @property({ type: String })
    icon?: IconName = undefined

    @property({ type: Boolean })
    large?: boolean = undefined

    @property()
    labelColor?: (typeof LOZENGE_COLORS)[number] = undefined

    @property({ type: Boolean })
    labelFontMedium?: boolean = undefined

    @property({ type: Boolean })
    labelNormalCase?: boolean = undefined

    render() {
        const icon = isNil(this.icon) ? '' : html`<zaptic-icon icon-name=${this.icon}></zaptic-icon>`
        return html`<div
            class="${classNames({
                wrapper: true,
                [this.color]: true,
                large: this.large !== undefined ? this.large : false,
            })}"
        >
            ${icon && html`<div class="icon-wrapper">${icon}</div>`}
            <div
                class="${classNames({
                    label: true,
                    [this.labelColor]: this.labelColor,
                    'font-medium': this.labelFontMedium !== undefined ? this.labelFontMedium : false,
                    'normal-case': this.labelNormalCase !== undefined ? this.labelNormalCase : false,
                })}"
            >
                ${this.label}
            </div>
        </div>`
    }
}
